(function () {
  const container = document.querySelector('.dynamic-text');
  if (!container) return;

  const sources = Array.from(container.querySelectorAll('.dynamic-source span'))
    .map((el) => el.textContent.trim())
    .filter(Boolean);
  if (!sources.length) return;

  const typedSpan = container.querySelector('#typed');
  const totype = sources;

  const delayTyping_char = 120;
  const delayErasing_text = 80;
  const delayTyping_text = 1200;

  let totypeIndex = 0;
  let charIndex = 0;
  let isRunning = false;
  let pendingTimeout = null;

  function typeText() {
    if (!isRunning) return;
    if (charIndex < totype[totypeIndex].length) {
      typedSpan.textContent += totype[totypeIndex].charAt(charIndex);
      charIndex++;
      pendingTimeout = setTimeout(typeText, delayTyping_char);
    } else {
      pendingTimeout = setTimeout(eraseText, delayTyping_text);
    }
  }

  function eraseText() {
    if (!isRunning) return;
    if (charIndex > 0) {
      typedSpan.textContent = totype[totypeIndex].substring(0, charIndex - 1);
      charIndex = charIndex - 1;
      pendingTimeout = setTimeout(eraseText, delayErasing_text);
    } else {
      totypeIndex = (totypeIndex + 1) % totype.length;
      pendingTimeout = setTimeout(typeText, 250);
    }
  }

  function start() {
    if (isRunning) return;
    isRunning = true;
    typeText();
  }

  function stop() {
    isRunning = false;
    if (pendingTimeout) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }
  }

  // Gated on visibility — without it the loop ran forever regardless of whether search was ever opened.
  const searchPanel = document.querySelector('.header-search');
  if (searchPanel && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          start();
        } else {
          stop();
        }
      }
    });
    observer.observe(searchPanel);
  } else {
    setTimeout(start, 400);
  }
})();
